module.exports = __webpack_public_path__ + "3f16e137/img/menu-icon.5f8facae.svg";